module.exports = __webpack_public_path__ + "img/20200514_152223.b02e3416.jpg";